import { type ReactNode } from 'react';
import { Pencil } from 'lucide-react';

type Props = {
  label: string;
  value: string | undefined;
  placeholder?: string;
  onEdit: () => void;
};

const HANDLE_CLS =
  'truncate text-sm font-medium text-text-primary tabular-nums';
const EMPTY_CLS = 'text-sm text-text-tertiary italic';
const BTN_CLS =
  'shrink-0 rounded-md px-sm py-1.5 text-xs text-text-secondary transition-colors hover:bg-surface-elevated hover:text-text-primary';

export function IgHandleRow({
  label,
  value,
  placeholder = 'Sin asignar',
  onEdit,
}: Props): ReactNode {
  return (
    <div className="flex items-center justify-between gap-base rounded-lg border border-border-subtle bg-white/[0.02] px-md py-sm">
      <div className="min-w-0 flex-1">
        <p className="text-xs uppercase tracking-wide text-text-tertiary">
          {label}
        </p>
        {value ? (
          <p className={HANDLE_CLS}>@{value}</p>
        ) : (
          <p className={EMPTY_CLS}>{placeholder}</p>
        )}
      </div>
      <button type="button" onClick={onEdit} className={BTN_CLS}>
        <Pencil size={12} className="mr-xs inline" />
        Editar
      </button>
    </div>
  );
}
